import { render, staticRenderFns } from "./SchemeTextForm.vue?vue&type=template&id=f240ffa4&scoped=true&"
import script from "./SchemeTextForm.vue?vue&type=script&lang=js&"
export * from "./SchemeTextForm.vue?vue&type=script&lang=js&"
import style0 from "./SchemeTextForm.vue?vue&type=style&index=0&id=f240ffa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f240ffa4",
  null
  
)

export default component.exports